import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface LatestUpdatesProps {
  movies: Movie[];
}

export default function LatestUpdates({ movies }: LatestUpdatesProps) {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-timer-flash-line text-accent-500 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最近更新
            </h2>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {movies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  title={`${movie.title} - 桃花影院高清不缓冲`}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-white text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="mt-2 px-0.5">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{movie.updateInfo}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}